import { render, staticRenderFns } from "./SendCatalogueModal.vue?vue&type=template&id=b59182ce&scoped=true&"
import script from "./SendCatalogueModal.vue?vue&type=script&lang=js&"
export * from "./SendCatalogueModal.vue?vue&type=script&lang=js&"
import style0 from "./SendCatalogueModal.vue?vue&type=style&index=0&id=b59182ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59182ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VCard,VCardActions,VDialog,VRow,VToolbar,VToolbarTitle})
